export const IS_MAIN_BANNER_ACTIVE = false;

export const IS_GENERAL_BANNER = false;

export const BANNER_CONTENT: Record<
  'technical' | 'general',
  {title: string; message: string}
> = {
  technical: {
    title: 'Upgrade in Progress',
    message:
      'Thank you for your patience! Follow our #announcements channel on Discord for updates.',
  },
  general: {
    title: 'Testnet in maintenance',
    message: 'Some features won’t work as expected',
  },
};
